import { useI18n } from 'vue-i18n'
import { getMonthName } from '@/lib/dates'

/**
 * The name of an event, as its pages write it in a title.
 *
 * An event can have a name of its own — the championship of a month — and shows that instead of its
 * type, which is only the short label of the chips. The name is built from the month the event opens
 * in, so it does not depend on the current date (see `eventNames` in the languages).
 */
export function useEventTitle()
{
  const { t, te } = useI18n()

  return function eventTitle(event, fallback = '') {
    const type = event?.eventType
    if (!type) return fallback

    return te(`eventNames.${type}`)
      ? t(`eventNames.${type}`, { month: getMonthName(event.dateStart) })
      : t(`eventTypes.${type}`)
  }
}
